import { createContext } from "react";

const AIVideoEditorContext = createContext();

export default AIVideoEditorContext;
